import { render, staticRenderFns } from "./BreadcrumbsView.vue?vue&type=template&id=4d988da0&"
import script from "./BreadcrumbsView.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports